import React from "react";
import "./Footer.css";
import footerlogo from "../Asset/Images/footer-logo.png";
import { IoCall } from "react-icons/io5";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer>
      <div className="footer-section py-5">
        <div className="container">
          <div className="row d-flex justify-content-center">
            {/* Logo and Description */}
            <div className="col-md-4 info-section mb-4 mb-md-0">
              <div className="footer-logo d-flex justify-content-start">
                <img src={footerlogo} alt="Logo" className="img-fluid mb-3 " />
              </div>
              <p className="text-white text-start">
                Discover the future of dining with MyFoodMyPrice. Prebook, save
                big, and enjoy your favorite meals at unbeatable prices. Join
                the revolution today.
              </p>
              <div className="footer-social">
                <a href="https://x.com/BiryaniPalayam" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-x-twitter"></i>
                </a>
                <a
                  href="https://www.facebook.com/biryanipalayamErode"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://youtu.be/fqcscOvUXLg" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  href="https://www.instagram.com/biryani.palayam/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>

            {/* Contact Information */}
            <div className="col-md-4 text-start mb-4 mb-md-0">
              <h4 className="text-white">Contact</h4>
              <p className="text-white">
                <i className="fas fa-phone icon-orange"></i> +91 9994210404
              </p>
              <p className="text-white">
                <i className="fas fa-envelope icon-orange"></i>{" "}
                Info@myfoodmyprice.com
              </p>
              <p className="text-white">
                <i className="fas fa-envelope icon-orange"></i>{" "}
                Support@myfoodmyprice.com
              </p>
            </div>

            {/* Addresses */}
            <div className="col-md-4 text-start">
              <h4 className="text-white">Our Offices</h4>
              <p className="text-white">
                <i className="fas fa-map-marker-alt icon-orange"></i> 3rd Floor,
                Hamid Complex, No. 190 - 192, Opp. Ibis Hotel, Anna Salai,
                Thousand Lights, <br />
                Chennai, Tamil Nadu - 600006
              </p>
              <p className="text-white">
                <i className="fas fa-map-marker-alt icon-orange"></i> Biryanipalayam <br />
                53/2 Sangu Nagar Main Road, <br />
                Erode - 638011
              </p>
            </div>
            <div className="col-12 mt-4">
              <ul className="d-flex justify-content-center align-items-center list-unstyled mb-0 fs-5 flex-wrap">
                <li>
                  <Link
                    to="/privacy-policy"
                    className="text-white text-decoration-none"
                  >
                    Privacy Policy
                  </Link>
                </li>

                <li className="mx-3 text-white">|</li>

                <li>
                  <Link
                    to="/terms-and-conditions"
                    className="text-white text-decoration-none"
                  >
                    Terms & Conditions
                  </Link>
                </li>

                <li className="mx-3 text-white">|</li>

                <li>
                  <Link
                    to="/shipping-delivery-policy"
                    className="text-white text-decoration-none"
                  >
                    Shipping & Delivery Policy
                  </Link>
                </li>

                <li className="mx-3 text-white">|</li>

                <li>
                  <Link
                    to="/cancellation-policy"
                    className="text-white text-decoration-none"
                  >
                    Cancellation Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Middle Area */}
      <div className="footer-middle-area">
        <div className="copyright-text">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                &copy; 2025{" "}
                <b>
                  <a
                    href="https://www.biryanipalayam.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Biryanipalayam
                  </a>
                </b>
                . All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>

      <a
        href="#"
        id="toTopBtn"
        className="cd-top text-replace js-cd-top cd-top--is-visible cd-top--fade-out"
        data-abc="true"
      ></a>
    </footer>
  );
};

export default Footer;
